<script setup lang="ts">
  import { ref } from 'vue'

  interface Props {
    showZoomedPreview: boolean
    zoomedPreviewPosition: { x: number; y: number }
    zoomedPreviewSize: number
  }

  interface Emits {
    (e: 'mousedown', event: MouseEvent): void
    (e: 'mousemove', event: MouseEvent): void
    (e: 'mouseup', event: MouseEvent): void
  }

  defineProps<Props>()
  defineEmits<Emits>()

  const canvas = ref<HTMLCanvasElement | null>(null)
  const zoomedPreviewCanvas = ref<HTMLCanvasElement | null>(null)

  defineExpose({
    canvas,
    zoomedPreviewCanvas
  })
</script>

<template>
  <div class="flex flex-1 items-center justify-center p-6">
    <div class="relative">
      <canvas
        ref="canvas"
        class="max-w-none border border-gray-200 shadow-sm"
        @mousedown="$emit('mousedown', $event)"
        @mousemove="$emit('mousemove', $event)"
        @mouseup="$emit('mouseup', $event)"
      ></canvas>
    </div>

    <!-- Zoomed Preview Window -->
    <div
      v-if="showZoomedPreview"
      class="pointer-events-none fixed z-[100]"
      :style="{
        left: zoomedPreviewPosition.x + 'px',
        top: zoomedPreviewPosition.y + 'px'
      }"
    >
      <div class="rounded-lg border-2 border-gray-300 bg-white p-2 shadow-lg">
        <div class="mb-1 text-center text-xs text-gray-600">Zoomed View</div>
        <canvas
          ref="zoomedPreviewCanvas"
          :width="zoomedPreviewSize"
          :height="zoomedPreviewSize"
          class="rounded border border-gray-200"
        ></canvas>
        <div class="mt-1 text-center text-xs text-gray-500">Red crosshairs = center</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  canvas {
    cursor: crosshair;
  }
</style>
